'use strict';
var charAt = require('../internals/string-multibyte').charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/advance-string-index.js
// module id = 147
// module chunks = 0